// This visit's session touch (utils/tracking/sessionTouch.ts), held in memory only:
// set once by plugins/session-touch.client.ts from the page load's first URL, kept
// through in-app navigation, gone on reload or when the tab closes. No cookie and no
// browser storage, so it needs no consent. Call in component setup (it uses the
// consent store).
import {
  buildSessionTouch,
  leadUtmFields,
  sessionTouchForLead,
  type SessionTouch,
} from '~/utils/tracking/sessionTouch';

// Module scope, written only in the browser (the server never captures one), so it
// is never shared between server requests.
const sessionTouch = shallowRef<SessionTouch | null>(null);

export const captureSessionTouch = (href: string, referrer: string) => {
  if (!import.meta.client || sessionTouch.value) return;
  try {
    sessionTouch.value = buildSessionTouch(new URL(href), referrer, Date.now());
  } catch {
    // unparseable URL: no session touch for this visit
  }
};

export const useSessionTouch = () => {
  const { adConsent } = useCookieConsent();

  // `session_touch` for a lead payload, always sent; click ids only with granted
  // ad consent.
  const sessionTouchField = () => ({ session_touch: sessionTouchForLead(sessionTouch.value, adConsent.value) });

  // The five top-level utm_* lead fields: this page's, or the landing's when this
  // page has none.
  const leadUtm = () => leadUtmFields(import.meta.client ? window.location.search : '', sessionTouch.value);

  return { sessionTouch: readonly(sessionTouch), sessionTouchField, leadUtm };
};
